import React from 'react';
import './Cards.css';

function Cards() {
    return (
<div className="cards-container">
    <div className="card-estiloso">
        <img src='./icons/card.svg' alt="Icono de producción audiovisual" className="card-icon"/>
        <h2 className="card-title">Producción audiovisual</h2>
        <p className="card-content">
            <strong>Ofrecemos un servicio de producción audiovisual</strong> diseñado para capturar la esencia única de tu marca. Nuestro enfoque creativo abarca desde la fotografía hasta la producción de videos para redes sociales, campañas publicitarias y mucho más.
        </p>
    </div>
    <div className="card-estiloso">
        <img src='./icons/card.svg' alt="Icono de producción audiovisual" className="card-icon"/>
        <h2 className="card-title">Tecnologia</h2>
        <p className="card-content">
            <strong>Nuestros servicios de diseño UX y programación</strong> abarcan la creación de experiencias digitales excepcionales para tu audiencia. Desde el diseño de landing pages atractivas que convierten visitantes en clientes, hasta la implementación de sólidos design systems que garantizan una coherencia visual y una experiencia de usuario fluida en todas las interacciones.
        </p>
    </div>
    <div className="card-estiloso">
        <img src='./icons/card.svg' alt="Icono de producción audiovisual" className="card-icon"/>
        <h2 className="card-title">Marketing</h2>
        <p className="card-content">
            <strong>Ofrecemos servicios de marketing digital y branding</strong> que impulsan y elevan marcas a través de estrategias cuidadosamente diseñadas para resaltar y comunicar de manera efectiva lo que desean demostrar. Nuestro enfoque se centra en destacar los valores, la personalidad y los atributos únicos de tu marca.
        </p>
    </div>
</div>


    );
}

export default Cards;
